import { isPojo } from 'es-sharp'

// 非空检验
export function notEmpty(rule, value, callback, source, options) {
    var msg = options.messages.required.replace("%s", rule.field)
    
    // 空值检测
    if (value === "" ||
        value === null ||
        value === undefined ||
        // []
        (Array.isArray(value) && value.length <= 0) || 
        // {}
        (isPojo(value) && Object.keys(value).length <= 0)) {
        return callback(new Error(msg))
    } else {
        return callback()
    }
}